import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'vs-filmstrip-item',
  styleUrls: ['_filmstrip.scss'],
  shadow: false,
})
export class VsFilmstripItem {
  /**
   @shortDescription Array of Object containing Images metadata
   @controlName slideArr */
  @Prop() slideArr: Array<any> = [];

  /**
   @shortDescription Class to apply on li elements based on size
   @controlName liClass */
  @Prop() liClass: string = '';

  /**
   @shortDescription Size of filmstrip images- small/large
   @controlName size */
  @Prop() size: string = '';

  /**
   @shortDescription Total number of images which is getting rendered
   @controlName numItems */
  @Prop() numItems: number;

  /**
   @shortDescription Name of filmstrip container
   @controlName name */
  @Prop() name: string;

  /**
   @shortDescription Reference of parent Filmstrip
   @controlName parentFilmstripRef */
  @Prop() parentFilmstripRef: any;

  private handleSlideFocus = e => {
    if (this.parentFilmstripRef.stateObject.mouseDown) {
      e.target.blur();
    }
  };

  private renderFsList() {
    return this.slideArr.map((slide, idx) => {
      return (
        <li
          key={idx}
          data-index={slide.dataIndex}
          data-position={slide.pos}
          class={{
            'isCloned': slide.isCloned,
            'isActive': slide.isActive,
            'li-container-style': true,
          }}
          role="listitem"
          aria-roledescription="slide"
          aria-setsize={this.numItems}
          aria-posinset={slide.posInset}
          aria-describedby={slide.imgCaption && !slide.isCloned ? `image-caption-${slide.dataIndex}` : ''}
          aria-hidden={slide.isActive ? 'false' : 'true'}
          tabindex={slide.isActive ? '0' : '-1'}
          onFocus={this.handleSlideFocus}
        >
          <img src={slide.imgPath} alt={slide.imgAltText} class={`${this.size === 'small' ? 'vs-img-small' : 'vs-img-large'}`} />
        </li>
      );
    });
  }

  render() {
    return (
      <Host>
        <ul
          class={`vs-fs-content ${this.size === 'small' ? 'vs-img-small' : 'vs-img-large'}`}
          role="list"
          aria-label={this.name}
          aria-roledescription="carousel"
          aria-atomic="false"
          aria-live="polite"
        >
          {this.slideArr.length && this.renderFsList()}
          <slot />
        </ul>
      </Host>
    );
  }
}
